module.exports = __webpack_public_path__ + "fonts/fa-regular-400.f0f82301.woff2";